module.exports = __webpack_public_path__ + "b666e0cf32bb8a98e7f004b620b91ef9.svg";